import { FormValidator, isValidPhone } from '~/modules';

export const validationSchema = FormValidator.object().shape({
  mobilePhone: FormValidator.string()
    .required('Insira um número de telefone')
    .test('mobilePhone', 'Insira um número de telefone válido', isValidPhone),
});

export type OnboardingPhoneFormValues = Record<'mobilePhone', string>;

export const initialValues: OnboardingPhoneFormValues = {
  mobilePhone: '',
};
